import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { allClients, client, updateClientNote, updateClientManager } from './types';

import {
  requestAllClientsSuccess,
  requestAllClientsFailure,
  requestClientSuccess,
  requestClientUpdateNoteSuccess,
  requestClientFailure,
} from './reducer';

const logger = new Logger('Saga:Monitor:Overview');
const loggerClientUpdateNote = new Logger('Saga:ClientUpdateNote');

export function* requestAllClientsSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  const optionalArchiveClients = action[1] ? { archived: true } : {};

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.monitor.clients', {
        entityId: action[0],
        ...optionalArchiveClients,
      }),
    );

    yield put(requestAllClientsSuccess(response.data));
  } catch (error) {
    logger.error('Failed to request monitored clients with the following error', error);
    yield put(requestAllClientsFailure(error));
  }
}

export function* requestClientSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  const { promise, id: entityId } = action;

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.monitor.client', { entityId }),
    );

    yield put(requestClientSuccess(entityId, response.data));
    promise && promise.resolve(response.data);
  } catch (error) {
    logger.error('Failed to request monitored clients with the following error', error);
    yield put(requestClientFailure(error));
    promise && promise.reject();
  }
}

export function* requestUpdateClientNoteSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  const { entityId, note, promise } = action;

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.platform.client', { entityId }),
      { note },
    );

    logger.info('Updated client notes');
    yield put(requestClientUpdateNoteSuccess(response.data.id, response.data));
    promise && promise.resolve(response.data);
  } catch (error) {
    loggerClientUpdateNote.error(
      'Failed to request update client note with the following error',
      error,
    );
    promise && promise.reject();
  }
}

export function* requestUpdateClientManagerSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  const { entityId, business, userCompanyId, promise } = action;

  try {
    const response = yield call(
      authApiService.patch,
      routerService.generate('api.platform.client', { entityId }),
      { business },
    );

    logger.info('Updated client manager');
    yield call(requestAllClientsSaga, { 0: userCompanyId });
    promise && promise.resolve(response.data);
  } catch (error) {
    loggerClientUpdateNote.error(
      'Failed to request update client manager with the following error',
      error,
    );
    promise && promise.reject();
  }
}

export default function* overviewSaga() {
  return yield all([
    takeLatest(allClients.request, requestAllClientsSaga),
    takeLatest(client.request, requestClientSaga),
    takeLatest(updateClientNote.request, requestUpdateClientNoteSaga),
    takeLatest(updateClientManager.request, requestUpdateClientManagerSaga),
  ]);
}
